import "./TextArea.scss";
import {
  MotifTextArea,
  MotifFormField,
  MotifErrorMessage,
} from "@ey-xd/motif-react";

export function TextArea({
  label,
  onChange,
  value,
  maxLength,
  id = crypto.randomUUID(),
  className,
  required = false,
  disabled = false,
  placeholder = "",
  isError,
  errorMessage,
  disableErrorPlaceholder = true,
  ...other
}) {
  function onInputChange(event) {
    const value = event.target?.value;
    if (value.includes("</") || value.includes(">") || value.includes("<")) {
      event.target.value = value.replace(/[<>/]/g, "");
      return;
    }
    if (event.target?.value) {
      if (maxLength && event.target?.value.length <= maxLength) {
        onChange(event);
      }
    }

    onChange(event);
  }
  return (
    <MotifFormField className="app-text-area">
      <MotifTextArea
        {...other}
        id={id}
        label={label}
        onChange={onInputChange}
        value={value}
        maxLength={maxLength}
        className={`${className}`}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
      />
      {isError ? (
        <MotifErrorMessage className="app-input-error-message">
          {errorMessage}
        </MotifErrorMessage>
      ) : !disableErrorPlaceholder ? (
        <div className="app-input-hide-error">No Error</div>
      ) : (
        <></>
      )}
    </MotifFormField>
  );
}
